export default __webpack_public_path__ + "static/media/js.70ba18a3.svg";